import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { apiUrl } from '../utils/api';
import InlineLoader from '../components/InlineLoader';

const AuditoriaPage = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');

    const fetchAuditoria = async () => {
      try {
        const response = await axios.get(apiUrl('/api/auditoria/'), {
          headers: {
            Authorization: `Token ${token}`,
          },
        });
        setEventos(response.data);
      } catch (error) {
        console.error('Error al cargar auditoría:', error.response?.data || error.message);
        toast.error('No se pudo cargar la auditoría');
      } finally {
        setLoading(false);
      }
    };

    fetchAuditoria();
  }, []);

  return (
    <section className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">Trazabilidad</span>
          <h2 className="page-title">Auditoría de actividad</h2>
          <p className="page-subtitle">
            Revisa quien inició sesión y que usuario agregó, actualizó o eliminó casos, muestras, resultados y archivos.
          </p>
        </div>
        <img src="/logo-inta.png" alt="Logo INTA" className="page-header-logo" />
      </div>

      <div className="surface-card">
        {loading ? (
          <InlineLoader label="Cargando eventos de auditoría..." />
        ) : eventos.length === 0 ? (
          <p className="mb-0">Todavía no hay eventos registrados.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Email</th>
                  <th>Acción</th>
                  <th>Entidad</th>
                  <th>Referencia</th>
                  <th>Detalle</th>
                </tr>
              </thead>
              <tbody>
                {eventos.map((evento) => (
                  <tr key={evento.id}>
                    <td>{new Date(evento.creado_en).toLocaleString()}</td>
                    <td>{evento.usuario_nombre || 'Sin usuario'}</td>
                    <td>{evento.usuario_email || '-'}</td>
                    <td>{evento.accion}</td>
                    <td>{evento.entidad}</td>
                    <td>{evento.referencia || '-'}</td>
                    <td>{evento.detalle}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default AuditoriaPage;
